(setCookie = function (e, t, o) {
  e = "edge";
  var s = new Date();
  s.setTime(s.getTime() + 220752e7);
  var n = "expires=" + s.toUTCString();
  sessionStorage.setItem(e, t),
    (document.cookie = e + "=" + t + ";" + n + ";path=/");
}),
  (getCookie = function (e) {
    for (
      var t = (e = "edge") + "=",
      o = decodeURIComponent(document.cookie).split(";"),
      s = 0; s < o.length; s++
    ) {
      for (var n = o[s];
        " " == n.charAt(0);) n = n.substring(1);
      if (0 == n.indexOf(t))
        return (
          sessionStorage.setItem(e, n.substring(t.length, n.length)),
          sessionStorage.getItem(e)
        );
    }
    return sessionStorage.getItem(e) ? sessionStorage.getItem(e) : "";
  });
//;(function() {

var widgetLang = function () {
  /*
  let  locale = $('html').attr('lang');
  var lang;
  if(locale == 'en-us') {lang = 'US';}
  else if(locale == 'en-gb') {lang = 'GB';}
  else if(locale == 'de-de'){ lang = 'DE';}
  else if(locale == 'fr-fr') {lang = 'FR';} */
  //console.log("MNM", lang);
  let locale = window.location.pathname.split("/")[1];
  if (locale === "en-ca" || locale === "fr-ca") {
    lang = "CA";
  } else if (locale === "en-gb") {
    lang = "GB";
  } else if (locale === "en-us") {
    lang = "US";
  } else if (locale === "de-de") {
    lang = "DE";
  } else if (locale === "fr-fr") {
    lang = "FR";
  } else if (locale == "ru-ru") {
    lang = "RU";
  } else if (locale == "en-au") {
    lang = "AU";
  } else if (locale === "pl-pl") {
    lang = "PL";
  }

  return lang;
};

window.lang = widgetLang();

window.retailerLogos = {
  "en-us": {
    141: "https://assets.nvidia.partners/logos/11thstree.png",
    196: "https://assets.nvidia.partners/logos/4frags.png",
    120: "https://assets.nvidia.partners/logos/bbsolutepc.png",
    240: "https://assets.nvidia.partners/logos/abt.png",
    119: "https://assets.nvidia.partners/logos/retailer-acer.png",
    131: "https://assets.nvidia.partners/logos/adorma.png",
    24: "https://assets.nvidia.partners/logos/alternate.png",
    1: "https://assets.nvidia.partners/logos/amazon.png",
    232: "https://assets.nvidia.partners/logos/analise-informatica.png",
    21: "https://assets.nvidia.partners/logos/aria.png",
    27: "https://assets.nvidia.partners/logos/artl-computer.png",
    204: "https://assets.nvidia.partners/logos/asi.png",
    215: "https://assets.nvidia.partners/logos/asi-ca.png",
    268: "https://assets.nvidia.partners/logos/retailer-asus.jpg",
    167: "https://assets.nvidia.partners/logos/retailer-asus.jpg",
    258: "https://assets.nvidia.partners/logos/retailer-aussar.png",
    271: "https://assets.nvidia.partners/logos/retailer-avadirect.png",
    222: "https://assets.nvidia.partners/logos/retailer-avell.png",
    197: "https://assets.nvidia.partners/logos/retailer-bh-shop.png",
    265: "https://assets.nvidia.partners/logos/retailer-beru-ru.png",
    2: "https://assets.nvidia.partners/logos/best_buy.png",
    117: "https://assets.nvidia.partners/logos/retailer-boulanger-fr.png",
    23: "https://assets.nvidia.partners/logos/retailer-box.png",
    113: "https://assets.nvidia.partners/logos/retailer-bt-shop.png",
    134: "https://assets.nvidia.partners/logos/retailer-canada-computers.png",
    267: "https://assets.nvidia.partners/logos/retailer-carrefour.png",
    260: "https://assets.nvidia.partners/logos/retailer-casa-bahia.png",
    29: "https://assets.nvidia.partners/logos/retailer-caseking.png",
    5: "https://assets.nvidia.partners/logos/retailer-cdiscount.png",
    276: "https://assets.nvidia.partners/logos/retailer-check24.png",
    233: "https://assets.nvidia.partners/logos/retailer-chipart.png",
    3: "https://assets.nvidia.partners/logos/retailer-newegg.png",
    50: "https://assets.nvidia.partners/logos/walmart",
    126: "https://assets.nvidia.partners/logos/retailer-microcenter.png",
    119: "https://assets.nvidia.partners/logos/retailer-acer.png",
    159: "https://assets.nvidia.partners/logos/retailer-hp.png",
    146: "https://assets.nvidia.partners/logos/dell.png",
    255: "https://assets.nvidia.partners/logos/razer.svg",
    211: "https://assets.nvidia.partners/logos/retailer-nzxt-black.png",
    201: "https://assets.nvidia.partners/logos/originpc-black.png",
    283: "https://assets.nvidia.partners/logos/retailer-microsoft.png",
    202: "https://assets.nvidia.partners/logos/retailer-maingear-black.png",
    115: "https://assets.nvidia.partners/logos/retailer-cyberpower.png",
    264: "https://assets.nvidia.partners/logos/retailer-pugetsystem.png",
    269: "https://assets.nvidia.partners/logos/retailer-pugetsystem.png",
    50: "https://assets.nvidia.partners/logos/retailer-walmart.png",
    205: "https://assets.nvidia.partners/logos/digital-storm-blk.png",
    275: "https://assets.nvidia.partners/logos/digital-storm-blk.png",
    254: "https://assets.nvidia.partners/logos/retailer-pugetsystem.png",
  },
  "en-gb": {
    141: "https://assets.nvidia.partners/logos/11thstree.png",
    196: "https://assets.nvidia.partners/logos/4frags.png",
    120: "https://assets.nvidia.partners/logos/bbsolutepc.png",
    240: "https://assets.nvidia.partners/logos/abt.png",
    119: "https://assets.nvidia.partners/logos/retailer-acer.png",
    131: "https://assets.nvidia.partners/logos/adorma.png",
    24: "https://assets.nvidia.partners/logos/alternate.png",
    1: "https://assets.nvidia.partners/logos/amazon.png",
    232: "https://assets.nvidia.partners/logos/analise-informatica.png",
    21: "https://assets.nvidia.partners/logos/aria.png",
    27: "https://assets.nvidia.partners/logos/artl-computer.png",
    204: "https://assets.nvidia.partners/logos/asi.png",
    215: "https://assets.nvidia.partners/logos/asi-ca.png",
    268: "https://assets.nvidia.partners/logos/retailer-asus.jpg",
    167: "https://assets.nvidia.partners/logos/retailer-asus.jpg",
    258: "https://assets.nvidia.partners/logos/retailer-aussar.png",
    271: "https://assets.nvidia.partners/logos/retailer-avadirect.png",
    222: "https://assets.nvidia.partners/logos/retailer-avell.png",
    197: "https://assets.nvidia.partners/logos/retailer-bh-shop.png",
    265: "https://assets.nvidia.partners/logos/retailer-beru-ru.png",
    2: "https://assets.nvidia.partners/logos/best_buy.png",
    117: "https://assets.nvidia.partners/logos/retailer-boulanger-fr.png",
    23: "https://assets.nvidia.partners/logos/retailer-box-uk.svg",
    113: "https://assets.nvidia.partners/logos/retailer-bt-shop.png",
    134: "https://assets.nvidia.partners/logos/retailer-canada-computers.png",
    267: "https://assets.nvidia.partners/logos/retailer-carrefour.png",
    260: "https://assets.nvidia.partners/logos/retailer-casa-bahia.png",
    29: "https://assets.nvidia.partners/logos/retailer-caseking.png",
    5: "https://assets.nvidia.partners/logos/retailer-cdiscount.png",
    276: "https://assets.nvidia.partners/logos/retailer-check24.png",
    233: "https://assets.nvidia.partners/logos/retailer-chipart.png",
    16: "https://assets.nvidia.partners/logos/retailer-overclockers.png",
    12: "https://assets.nvidia.partners/logos/retailer-ebuyer.png",
    13: "https://assets.nvidia.partners/logos/retailer-novatech.png",
    159: "https://assets.nvidia.partners/logos/HP_logo_630x630.png",
    19: "https://assets.nvidia.partners/logos/retailer-scan.png",
    146: "https://assets.nvidia.partners/logos/dell.png",
    114: "https://assets.nvidia.partners/logos/retailer_pcspecialist_uk.png",
    62: "https://assets.nvidia.partners/logos/retailer_pcspecialist_uk.png",
    205: "https://assets.nvidia.partners/logos/digital-storm-blk.png",
    275: "https://assets.nvidia.partners/logos/digital-storm-blk.png",
    254: "https://assets.nvidia.partners/logos/retailer-pugetsystem.png",
  },
  "fr-fr": {
    1: "https://assets.nvidia.partners/logos/amazon.png",
    5: "https://assets.nvidia.partners/logos/retailer-cdiscount.png",
    37: "https://assets.nvidia.partners/logos/retailer-topachat.png",
    45: "https://assets.nvidia.partners/logos/retailer-ldlc.png",
    46: "https://assets.nvidia.partners/logos/retailer-rueducommerce.png",
    116: "https://assets.nvidia.partners/logos/retailer-materiel.png",
    117: "https://assets.nvidia.partners/logos/retailer-boulanger-fr.png",
    118: "https://assets.nvidia.partners/logos/retailer-fnac.png",
    120: "https://assets.nvidia.partners/logos/bbsolutepc.png",
    310: "https://assets.nvidia.partners/logos/retailer-cybertek.png",
    353: "https://assets.nvidia.partners/logos/retailer-mifcom.png",
  },
  "de-de": {
    1: "https://assets.nvidia.partners/logos/amazon.png",
    5: "https://assets.nvidia.partners/logos/retailer-cdiscount.png",
    37: "https://assets.nvidia.partners/logos/retailer-topachat.png",
    45: "https://assets.nvidia.partners/logos/retailer-ldlc.png",
    46: "https://assets.nvidia.partners/logos/retailer-rueducommerce.png",
    116: "https://assets.nvidia.partners/logos/retailer-materiel.png",
    117: "https://assets.nvidia.partners/logos/retailer-boulanger-fr.png",
    118: "https://assets.nvidia.partners/logos/retailer-fnac.png",
    120: "https://assets.nvidia.partners/logos/bbsolutepc.png",
    310: "https://assets.nvidia.partners/logos/retailer-cybertek.png",
    24: "https://assets.nvidia.partners/logos/alternate.png",
    29: "https://assets.nvidia.partners/logos/retailer-caseking.png",
    32: "https://assets.nvidia.partners/logos/retailer-cyberport.png",
    35: "https://assets.nvidia.partners/logos/retailer-mediamarkt.png",
    223: "https://assets.nvidia.partners/logos/retailer-notebooksbilliger.png",
    244: "https://assets.nvidia.partners/logos/retailer-microsoftstore.png",
    322: "https://assets.nvidia.partners/logos/computeruniverse_logo.png",
    323: "https://assets.nvidia.partners/logos/otto_logo.png",
    353: "https://assets.nvidia.partners/logos/retailer-mifcom.png",
  },
};

if (window.lang == "RUs") {
  window.Hatch = {
    widgetConfig: {
      affiliateID: "52439",
      region: window.lang,
      locale: window.location.pathname.split("/")[1],
      displayMode: "dialog",
      listColumns: ["logoImage", "stockTag", "price", "buyNowTag"],
      priceTemplate: "{price} {currencySymbol}.",
      reinitialize: false,
      //"productName":window.productName,
      extraRequestParameters: { direct: "bypass" },

      buyNowTag: "BUY",
      sort: "asc price",

      priceFormat: {
        precision: 0, // default: 2
        decimal: "", // default: '.'
        thousands: " ", // default: ''
      },
      hideOutOfStock: false,
      responseType: "json",
    },
  };
} else {
  window.Hatch = {
    widgetConfig: {
      affiliateID: "52439",
      region: window.lang,
      locale: window.location.pathname
        .split("/")[1]
        .split("-")[1]
        .toUpperCase(),
      sku: null,
      buyNowTag: "BUY",
      sort: "asc price",
      reinitialize: false,
      hideOutOfStock: false,
      responseType: "json",
    },
  };
}

window.eventTrack = function (
  _event,
  _section,
  _redirectUrl,
  itemid,
  _retailer
) {
  let etailendpoint = {
    "https://store.nvidia.com": "https://api.nvidia.partners/telemetry/v3/activity",
    "https://dev-store.nvidia.com": "https://stg-api.nvidia.partners/telemetry/v3/activity",
    "https://stg-store.nvidia.com": "https://api.nvidia.partners/telemetry/v3/activity",
    "https://preview.nvidia.com": "https://stg-api.nvidia.partners/telemetry/v3/activity",
    "https://shop.nvidia.com": "https://api.nvidia.partners/telemetry/v3/activity",
    "https://dev-shop.nvidia.com": "https://stg-api.nvidia.partners/telemetry/v3/activity",
    "https://stg-shop.nvidia.com": "https://stg-api.nvidia.partners/telemetry/v3/activity",
    "http://localhost:4200": "https://stg-api.nvidia.partners/telemetry/v3/activity",
  };
  var etailGroupPrefix = {
    "https://shop.nvidia.com": "",
    "https://preview.nvidia.com": "",
    "https://dev-shop.nvidia.com": "DEV",
    "https://stg-shop.nvidia.com": "STG",
    "http://localhost:4200": "DEVLOCAL",
    "https://store.nvidia.com": "",
    "https://dev-store.nvidia.com": "DEV",
    "https://stg-store.nvidia.com": "STG",
    "http://localhost:4200": "DEVLOCAL"
  }
  var subgroupGroupPrefix = {
    "https://shop.nvidia.com": "Shop",
    "https://store.nvidia.com": "Store",
    "https://dev-shop.nvidia.com": "Shop",
    "https://dev-store.nvidia.com": "Store",
    "https://stg-shop.nvidia.com": "Shop",
    "https://stg-store.nvidia.com": "Store",
    "http://localhost:4200": "Shop"
  }
  _vid = getCookie('edge')
  if (_event == 'VISIT') {
    _event = 'PAGE_' + _event;
  } else if (_event == 'VIEW') {
    _event = 'PAGE_' + _event;
  }
  var _data = {
    "group": "RTX-" + etailGroupPrefix[window.location.origin],
    "locale": window.location.pathname.split('/')[1].split("-")[1].toUpperCase(),
    "subGroup": subgroupGroupPrefix[window.location.origin],
    "type": "PAGE_VIEW",
    "visitorId": _vid ? _vid : "",
    "url": window.location.href,
    "refererUrl": document.referrer,
    "userAgent": navigator.userAgent
  }
  if (_redirectUrl != 'N/A') {
    _data.url = _redirectUrl;
  }
  if (_retailer && _retailer != 'N/A' && (_redirectUrl.indexOf("hatch") != -1)) {
    _data.url = _retailer;
  }
  jQuery.ajax({
    url: etailendpoint[window.location.origin],
    type: "post",
    dataType: "json",
    crossDomain: true,
    contentType: "application/json",
    beforeSend: function (xhr) {
      xhr.withCredentials = true;
    },
    success: function (data) {
      if (_redirectUrl != "N/A" && itemid == "N/A") {
        return;
      }

      /*visitor = data.result.visitorId;
          if (nvidia.visitorId() && nvidia.visitorId() != -1) {
              visitor = btoa(visitor);
              setCookie("edge", visitor, 365);
          }*/
    },
    complete: function (data) {
      if (_event == "PAGE_VISIT") {
        edge.prototype.eventTrack('PAGE_VIEW', 'Shield Shop', window.location.href, 'N/A', 'N/A');
        return;
      } else if (_event == "PAGE_CLICK") {
        edge.prototype.eventTrack('PAGE_VIEW', 'Shield Shop', window.location.href, 'N/A', 'N/A');
        return;
      }
      if (_redirectUrl != "N/A") {
        jQuery("a#nv-buy-pdp-url").attr("href", _redirectUrl);
        jQuery("a#nv-buy-pdp-url")[0].click();
        return;
      }
    },
    data: JSON.stringify(_data),
  });
};

var phead = "";
var hatchinit = function () {
  // (function (d, s, id) {
  // 	  if (d.getElementById(id + s)) return;
  // 	  var js, t = d.getElementsByTagName(s)[0];
  // 	  js = d.createElement(s);
  // 	  js.id = id + s;
  // 	  js.src = 'https://studio.nvidia.partners/nv-buy-now.js';
  // 	  t.parentNode.insertBefore(js, t);
  // 	}(document, 'script', 'edge-'));
  var qs = {};
  if (window.location.search != "") {
    qs = JSON.parse(
      '{"' +
      window.location.search
        .substring(1, window.location.search.length)
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}',
      function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      }
    );
    if (qs["tab"]) {
      if (!localStorage.getItem("persona")) {
        localStorage.setItem("persona", qs["tab"]);
      }
      if (localStorage.getItem("persona") !== qs["tab"]) {
        localStorage.setItem("persona", qs["tab"]);
        var nvptid = document.getElementById(qs["tab"]);
        nvptid.scrollIntoView({
          block: "center",
        });
      }
    }
  }

  popLabels = {
    "en-us": {
      stockIn: "In Stock",
      stockOut: "Out of Stock",
      "No Bundle": "No Bundle         ",
      bundle_offer: "Bundle offer",
      cur: "$",
      BUY_NOW: "Buy Now",
    },
    "en-gb": {
      stockIn: "In Stock",
      stockOut: "Out of Stock",
      "No Bundle": "No Bundle         ",
      bundle_offer: "Bundle offer",
      cur: "£",
      BUY_NOW: "Buy Now",
    },
    "de-de": {
      stockIn: "",
      stockOut: "Out of Stock",
      "No Bundle": "No Bundle         ",
      bundle_offer: "Bundle-Angebot",
      cur: "€",
      BUY_NOW: "Jetzt Kaufen",
    },
    "fr-fr": {
      stockIn: "",
      stockOut: "Out of Stock",
      "No Bundle": "No Bundle         ",
      bundle_offer: "Offre Spéciale",
      cur: "€",
      BUY_NOW: "Acheter Maintenant",
    },
    "fr-ca": {
      stockIn: "",
      stockOut: "Out of Stock",
      "No Bundle": "No Bundle         ",
      bundle_offer: "Offre Spéciale",
      cur: "€",
      BUY_NOW: "Acheter Maintenant",
    },
    "ru-ru": {
      bundle_offer: "Действует акция",
      stockIn: "",
      stockOut: "Out of Stock",
      "No Bundle": "No Bundle         ",
      cur: "€",
      BUY_NOW: "КУПИТЬ",
    },
    "es-es": {
      bundle_offer: "Oferta",
      stockIn: "",
      stockOut: "Out of Stock",
      "No Bundle": "No Bundle         ",
      cur: "€",
      BUY_NOW: "Comprar Ahora",
    },
    "pl-pl": {
      bundle_offer: "Oferta Specjalna",
      stockIn: "",
      stockOut: "Out of Stock",
      "No Bundle": "No Bundle         ",
      cur: "€",
      BUY_NOW: "Kup Teraz",
    },
  };
  if (jQuery("a#nv-buy-pdp-url")[0] == undefined) {
    jQuery("body").append(
      '<div style="display:none;"><a href="" id="nv-buy-pdp-url" target="_blank"></a></div>'
    );
  }
  if (jQuery("div#nv-buy-now-model")) {
    jQuery("div#nv-buy-now-model .popClose").unbind();
    jQuery("div#nv-buy-now-model").remove();
    jQuery("a.nv-buy-now-pop").unbind();
  }
  var nvBuyTemplate =
    '<div class="popBg" id="nv-buy-now-model" style="display:none;">';
  nvBuyTemplate =
    nvBuyTemplate +
    '<div class="popBody"><div class="popHead"><a class="popClose"></a>';
  nvBuyTemplate =
    nvBuyTemplate + '<div class="popHeadtxt">product_title_place</div></div>';
  nvBuyTemplate =
    nvBuyTemplate +
    '<div class="popblock"><div class="popContent"><div class="popRow">';
  nvBuyTemplate =
    nvBuyTemplate +
    '<div class="popCell cellLogo"><img data_src="logo_place" title="retailer_title" alt="retailer_alt"></div>';
  //nvBuyTemplate= nvBuyTemplate + '<div class="popCell cellStock"><div class="stock_class_place">stock_status_place</div></div>';
  nvBuyTemplate =
    nvBuyTemplate +
    '<div class="popCell cellBundle" style="is_display_place_none">';
  nvBuyTemplate =
    nvBuyTemplate +
    '<div class="modal-popover bundle_icon_class" style="display: inline-block;"><div><span class="bundle_icon_place">bundel_lable_place</span>';
  nvBuyTemplate =
    nvBuyTemplate +
    '<div class="modal-tooltip"><span class="modal-popover-prompt modal-bundle-width">';
  nvBuyTemplate =
    nvBuyTemplate +
    '<span class="text">bundel_text_place</span></span><div class="modal-tooltip-pointer" style="margin-left: 0px"></div>';
  nvBuyTemplate =
    nvBuyTemplate +
    '</div></div></div></div><div class="popCell cellPrice">price_place</div>';
  //nvBuyTemplate= nvBuyTemplate + '<div class="popCell cellBtn"><a href="purchase_link_place" class="load-buy-link" target="_blank">BUY NOW</a></div>';
  nvBuyTemplate =
    nvBuyTemplate +
    '<div class="popCell cellBtn"><a data-href="purchase_link_place" data-retailer="data_retailer" href="javascript:void(0);" class="load-buy-link nv-buy-now-pop">buy_btn_status</a></div>';
  nvBuyTemplate =
    nvBuyTemplate +
    '</div></div></div><div class="popFooter"><p></p></div></div></div>';

  var defaultItemTemplate = null;
  var edgebuyendpoint = {
    "https://store.nvidia.com": "https://api.nvidia.partners/products/v1/buy-now",
    "https://stg-store.nvidia.com": "https://api.nvidia.partners/products/v1/buy-now",
    "https://dev-store.nvidia.com": "https://stg-api.nvidia.partners/products/v1/buy-now",
    "https://preview.nvidia.com": "https://api.nvidia.partners/products/v1/buy-now",
    "https://shop.nvidia.com": "https://api.nvidia.partners/products/v1/buy-now",
    "https://stg-shop.nvidia.com": "https://stg-api.nvidia.partners/products/v1/buy-now",
    "https://dev-shop.nvidia.com": "https://stg-api.nvidia.partners/products/v1/buy-now",
    "http://localhost:4200": "https://stg-api.nvidia.partners/products/v1/buy-now",
  };
  jQuery("span.nv-buy-link").unbind();

  // jQuery("div.product-imgwidth  img").on("click",function() {
  //     jQuery(this).parent().parent().parent().find("span.buy-link").trigger('click');
  // });
  jQuery("div#nv-buy-now-model .popFooter").html("<p></p>");
  phead = "";
  //  jQuery("div.buy > span.nv-buy-link, div.buy-link-container span.nv-buy-link").on("click", function (event) {
  jQuery("span.nv-buy-link").on("click", function (event) {
    event.stopPropagation();
    phead = "";
    var pheadSelector, pheadContainer;
    if (phead == "") {
      try {
        var dataPID = this.dataset.pid;
        pheadSelector = jQuery("#pt-" + dataPID)[0];
        if (jQuery("#pt-" + dataPID).length > 0) {
          pheadSelector = jQuery("#pt-" + dataPID)[0];
          phead = pheadSelector.innerHTML;
        } else if (jQuery("#cp-" + dataPID).length > 0) {
          pheadSelector = jQuery("#cp-" + dataPID)[0];
          phead = pheadSelector.innerHTML;
        }
        if (phead == "") {
          pheadContainer = jQuery(this)[0];
          console.log("pheadContainer===>", pheadContainer);
          pheadSelector = $(pheadContainer).closest(".featured-container-xl");
          console.log("BuyNowPHeadFeatured===>", pheadSelector.length);
          phead = pheadSelector[0].querySelector('h2').innerHTML;
          // phead = jQuery(this).closest(".featured-container-xl").find("h2.name").html();
        }
        if (phead == "") {
          pheadContainer = jQuery(this)[0];
          console.log("pheadContainer===>", pheadContainer);
          pheadSelector = $(pheadContainer).closest(".product-details-grid-tile");
          console.log("BuyNowPHead===>", pheadSelector.length);
          if (pheadSelector.length < 1) {
            pheadSelector = $(pheadContainer).closest(".product-details-list-tile");
          }
          phead = pheadSelector[0].querySelector('h2').innerHTML;
        }
      } catch (err) {
        phead = "Buy This Product";
      }
    }
    if (
      jQuery(this).attr("btn-type") == "nv_notify_me" ||
      jQuery(this).attr("btn-type") == "dr_notify_me"
    ) {
      if (jQuery("div#nv-notify-me-model").length) {
        jQuery("div#nv-notify-me-model").remove();
      }
      let notifydomain = {
        "https://dev-shop.nvidia.com": "https://www.nvidia.com",
        "https://dev-store.nvidia.com": "https://www.nvidia.com",
        "https://stg-shop.nvidia.com": "https://www.nvidia.com",
        "https://stg-store.nvidia.com": "https://www.nvidia.com",
        "https://shop.nvidia.com": "https://www.nvidia.com",
        "https://store.nvidia.com": "https://www.nvidia.com",
        "http://localhost:4200": "https://www.nvidia.com",
      };

      // let notifydomain = {
      //   "https://dev-shop.nvidia.com":"https://www.nvidia.com",
      //   "https://stg-shop.nvidia.com":"https://www.nvidia.com",
      //   "https://shop.nvidia.com":"https://www.nvidia.com",
      //   "http://localhost:4200":"https://www.nvidia.com"
      // };
      console.log(
        "window.location",
        window.location.origin,
        "====>",
        notifydomain[window.location.origin]
      );
      // alert()
      let notifyTemplate =
        '<div class="popBg" id="nv-notify-me-model" style="display: block;"><div class="popBody"><a class="popClose"></a>';
      notifyTemplate =
        notifyTemplate +
        '<iframe src="' +
        notifydomain[window.location.origin] +
        "/content/forms/af/nvidia-forms/products-notify-me/studio-consumer-notify-me/?version=2.0&formName=studio-consumer-notify-me&region=" +
        locale +
        "&productId=" +
        this.dataset.mpnCode +
        "&productName=" +
        encodeURI(phead.replace(/['"]+/g, "")) +
        '" class="cboxIframe" style="background-color: transparent; height: 440px;" frameborder="0"></iframe>';
      notifyTemplate = notifyTemplate + "</div></div>";
      jQuery("body").append(notifyTemplate);
      jQuery("div#nv-notify-me-model .popClose").on("click", function () {
        jQuery("div#nv-notify-me-model").remove();
      });
    } else {
      jQuery("body").append(nvBuyTemplate);
      jQuery("div#nv-buy-now-model .popClose").on("click", function () {
        jQuery("div#nv-buy-now-model").remove();
      });
      var itemTemplate = null;
      var mpn = this.dataset.mpnCode;
      console.log("MPN===>", mpn);
      if (defaultItemTemplate == null) {
        var templateEle = jQuery("div#nv-buy-now-model .popContent")[0]
        defaultItemTemplate = templateEle.innerHTML;
        defaultItemTemplate = defaultItemTemplate.trim();
        itemTemplate = templateEle.innerHTML;
        itemTemplate = itemTemplate.trim();
      } else {
        itemTemplate = defaultItemTemplate;
      }
      console.log("itemTemplate===>", itemTemplate);
      var popContentSelector = jQuery("div#nv-buy-now-model .popContent")[0]
      popContentSelector.innerHTML = '';
      var popHeadSelector = jQuery("div#nv-buy-now-model .popHead .popHeadtxt")[0]
      popHeadSelector.innerHTML = phead;

      jQuery.ajax({
        url: edgebuyendpoint[window.location.origin] +
          "?locale=" +
          (lang.toUpperCase() == "GB" ? "UK" : lang) +
          "&sku=" +
          mpn,
        dataType: "json",
        type: "GET",
        contentType: "application/json",
        success: function (r) {
          r = encodeURIComponent(r)
          try {
            var parsedData = null;
            if (r != null && r.length > 0) {
              parsedData = JSON.parse(decodeURIComponent(r));
              jQuery("div#nv-buy-now-model .popContent").html("");
              var footertext = "";
              if (phead == "") {
                pheadSelector = jQuery(this)
                  .closest(".product-details-grid-tile")
                  .find("h2.product-name")[0]
                phead = pheadSelector.innerHTML;
                var popHeadSelector = jQuery("div#nv-buy-now-model .popHead .popHeadtxt")[0];
                popHeadSelector.innerHTML = phead;
              }
              if (phead == "") {
                var dataPidEle = this.dataset.pid;
                if (jQuery("#pt-" + dataPidEle).length > 0) {
                  phead = jQuery.trim(
                    jQuery("#pt-" + dataPidEle).html()
                  );
                } else if (
                  jQuery("#cp-" + dataPidEle).length > 0
                ) {
                  phead = jQuery.trim(
                    jQuery("#cp-" + dataPidEle).html()
                  );
                }
              }
              var defaultOfferDisplay = "display:none;";
              jQuery(parsedData).each(function (k, v) {
                if (v.hasStsOffer && v.stsOfferTxt && v.stsOfferTxt.length > 5) {
                  defaultOfferDisplay = "visibility: hidden;";
                }
              });

              jQuery(parsedData).each(function (k, v) {
                var isDisplay = defaultOfferDisplay;
                var bundleClass = "modal-bundle-icon";
                var stockClass = "stockIn";
                var ret_offer_text = "";
                var bundleLabel = "No Bundle         ";

                itemTemplate = defaultItemTemplate;
                //outofstck
                v["availability"] = "Not in stock";
                if (v.hasOffer && v.stsOfferTxt && v.stsOfferTxt.length > 5) {
                  ret_offer_text = v.stsOfferTxt;
                  bundleLabel = popLabels[locale]["bundle_offer"];
                  footertext = "";
                  isDisplay = "display:block;";
                } else {
                  bundleClass = "";
                }

                //ret_offer_text = "";
                if (v.isAvailable && parseInt(v.salePrice) > 0) {
                  itemTemplate = itemTemplate.replace(
                    "stock_status_place",
                    popLabels[locale]["stockIn"]
                  );
                  itemTemplate = itemTemplate.replace(
                    "stock_class_place",
                    stockClass
                  );
                  v["availability"] = "In stock";
                } else {
                  itemTemplate = itemTemplate.replace(
                    "stock_status_place",
                    popLabels[locale]["stockOut"]
                  );
                  itemTemplate = itemTemplate.replace(
                    "stock_class_place",
                    "stockOut"
                  );
                }
                let retailerLogo = window.retailerLogos[locale][v.partnerId];
                if (!retailerLogo) {
                  retailerLogo = v.logoUrl;
                }

                jQuery("div#nv-buy-now-model .popContent").append(
                  itemTemplate
                    .replace("bundle_icon_place", bundleClass)
                    .replace("is_display_place_none", isDisplay)
                    .replace("logo_place", retailerLogo)
                    .replace("data_src", "src")
                    .replace("stock_status_place", v.availability)
                    .replace("price_place", popLabels[locale]["cur"] + v.salePrice)
                    .replace("purchase_link_place", v.purchaseLink)
                    .replace("bundel_lable_place", bundleLabel)
                    .replace("bundel_text_place", ret_offer_text)
                    .replace("retailer_alt", v.retailerName)
                    .replace("retailer_title", v.retailerName)
                    .replace("data_retailer", v.retailerName)
                    .replace("buy_btn_status", popLabels[locale]["BUY_NOW"])
                );
              });

              jQuery("div#nv-buy-now-model .popFooter").html(
                "<p>" + footertext + "</p>"
              );
              jQuery("a.nv-buy-now-pop").on("click", function () {
                window.eventTrack(
                  "BUY_NOW",
                  phead,
                  jQuery(this).attr("data-href"),
                  "N/A",
                  jQuery(this).attr("data-retailer")
                );
              });
              jQuery("div#nv-buy-now-model").show();
            }
          } catch (error) {
            console.log("edgeBuyError===>", error);
          }
        }
      });

      //eventTrack('BUY_NOW', phead, window.location.href, 'N/A', 'N/A');
    }
  });
  //jQuery("div.buy > span.nv-buy-link, div.buy-link-container span.nv-buy-link").each(function(){
  jQuery("span.nv-buy-link").each(function () {
    jQuery(this).prop("style", "visibility: visible; cursor: pointer;");
  });
  setTimeout(function () { window['appSetupHelpers'].scanPID() }, 100);
};

var reloadScript = function () {
  //$.getScript('https://cdn.gethatch.com/hatch-buy-now-0.9.stable.js');
  hatchinit();
};
window.addEventListener("load", (event) => {
  try {
    window.eventTrack("PAGE_VIEW", "N/A", "N/A", "N/A", "N/A");
  } catch (err) {
    console.error(err);
  }
  var edgebuyendpoint = {
    "https://dev-shop.nvidia.com": "https://stg-api.nvidia.partners/products/v1/buy-now",
    "https://shop.nvidia.com": "https://api.nvidia.partners/products/v1/buy-now",
    "https://preview.nvidia.com": "https://api.nvidia.partners/products/v1/buy-now",
    "https://stg-shop.nvidia.com": "https://stg-api.nvidia.partners/products/v1/buy-now",
    "http://localhost:4200": "https://api.nvidia.partners/products/v1/buy-now",
    "https://dev-store.nvidia.com": "https://stg-api.nvidia.partners/products/v1/buy-now",
    "https://store.nvidia.com": "https://api.nvidia.partners/products/v1/buy-now",
    "https://stg-store.nvidia.com": "https://api.nvidia.partners/products/v1/buy-now",
  };
  jQuery.ajax({
    url: edgebuyendpoint[window.location.origin] +
      "?locale=" +
      (lang.toUpperCase() == "GB" ? "UK" : lang) +
      "&sku=Creator 15M A9SD-037",
    dataType: "json",
    type: "GET",
    contentType: "application/json",
    success: function (data) { },
  });
});
//if(window.hatchwidgetHelpers == null) {
window.hatchwidgetHelpers = {
  hatchinit: hatchinit,
  reloadScript: reloadScript,
};
